import { ITripOutputDto } from './trip-output-dto.interface';

export interface IUnfoldTripOpeningDto {
    /** checkpointId of the original checkpoints after the hub that move to this opening */
    checkpointIds: string[];
    /** Planned departure from the hub */
    scheduledStart: string;
    vehicleId?: string;
    vehicleExternalId?: string;
    driverId?: string;
    driverExternalId?: string;
}

export interface IUnfoldTripDto {
    openings: IUnfoldTripOpeningDto[];
}

export interface IUnfoldTripOutputDto {
    /** The original trip, cut at the hub */
    trip: ITripOutputDto;
    openings: ITripOutputDto[];
}
